import React from 'react';
import { useSelector } from 'react-redux';

import withWidgetTestId from '@swf/core/hoc/withWidgetTestId';
import type { WidgetFC } from '@swf/core/types/Widget';

import Markets from './components/Markets/Markets';
import { sportsEventPageWidgetModel, useSportsEventPageWidget } from './model';

const SportsEventPageWidget: WidgetFC = () => {
  const { widgetSelect } = useSportsEventPageWidget();
  const isLoading = useSelector(widgetSelect.isLoading);
  const hasPreloaded = useSelector(widgetSelect.hasPreloaded);

  if (isLoading && !hasPreloaded) {
    return null;
  }

  return <Markets />;
};

SportsEventPageWidget.model = sportsEventPageWidgetModel;

export default withWidgetTestId(SportsEventPageWidget, 'sports-event-page');
